import { Config } from "@measured/puck";
import {
  OrganizationHero,
  OrganizationAbout,
  OrganizationEventsList,
  OrganizationStats,
  OrganizationSocialLinks,
  OrganizationContact,
} from "./components/organization";
import {
  EventHero,
  EventDescription,
  EventTicketSelection,
  EventDetails,
} from "./components/event";
import { Spacer, Text, Button, Divider } from "./components/base";
import { RootPropsProvider } from "./context";

// Organization Page Config
export const organizationConfig: Config = {
  root: {
    render: ({ children, ...rootProps }) => {
      return (
        <RootPropsProvider
          value={{
            organization: (rootProps as any).organization,
            events: (rootProps as any).events,
          }}
        >
          {children}
        </RootPropsProvider>
      );
    },
  },
  components: {
    // Organization Components
    OrganizationHero,
    OrganizationAbout,
    OrganizationEventsList,
    OrganizationStats,
    OrganizationSocialLinks,
    OrganizationContact,
    // Base Components
    Spacer,
    Text,
    Button,
    Divider,
  },
};

// Event Page Config
export const eventConfig: Config = {
  root: {
    render: ({ children, ...rootProps }) => {
      return (
        <RootPropsProvider
          value={{
            event: (rootProps as any).event,
            tickets: (rootProps as any).tickets,
          }}
        >
          {children}
        </RootPropsProvider>
      );
    },
  },
  components: {
    // Event Components
    EventHero,
    EventDescription,
    EventTicketSelection,
    EventDetails,
    // Base Components
    Spacer,
    Text,
    Button,
    Divider,
  },
};

